/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferenceCompany
 */
export interface ReferenceCompany {
    /**
     * 企業ID
     * @type {number}
     * @memberof ReferenceCompany
     */
    id: number;
    /**
     * 企業名
     * @type {string}
     * @memberof ReferenceCompany
     */
    companyName: string;
    /**
     * ロゴ画像URL
     * @type {string}
     * @memberof ReferenceCompany
     */
    logoUrl?: string;
}

export function ReferenceCompanyFromJSON(json: any): ReferenceCompany {
    return ReferenceCompanyFromJSONTyped(json, false);
}

export function ReferenceCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferenceCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyName': json['company_name'],
        'logoUrl': !exists(json, 'logo_url') ? undefined : json['logo_url'],
    };
}

export function ReferenceCompanyToJSON(value?: ReferenceCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'company_name': value.companyName,
        'logo_url': value.logoUrl,
    };
}

